import { Button, Spacing, Text, Title } from '@vkontakte/vkui';
import React, { type Dispatch, type SetStateAction, memo, useCallback } from 'react';
import { emitAnalyticEvent } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import type { AsidePollProps, PollStep } from 'reactApp/ui/AsidePollModal/AsidePollModal.types';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

import styles from './Intro.css';

type IntroProps = Pick<AsidePollProps, 'introTitle' | 'introImg' | 'introText' | 'introBtnText' | 'analyticsPrefix'> & {
    setStep: Dispatch<SetStateAction<PollStep>>;
};

export const Intro = memo<IntroProps>(({ introImg, introTitle, introText, introBtnText, analyticsPrefix, setStep }) => {
    const handleStartPoll = useCallback(() => {
        setStep(0);
        emitAnalyticEvent(AnalyticEventNames.ASIDE_POLL_START);
        sendPaymentGa({
            action: 'click',
            eventCategory: ECategoryGa.balloon,
            name: analyticsPrefix,
        });
    }, [setStep, analyticsPrefix]);

    return (
        <>
            <img src={introImg} alt={introTitle} className={styles.image} height={160} />
            <div className={styles.content}>
                <Title level="1" Component="span">
                    {introTitle}
                </Title>
                <Spacing size={8} />
                <Text>{introText}</Text>
                <Spacing size={20} />
                <Button mode="primary" appearance="accent-invariable" size="l" onClick={handleStartPoll}>
                    {introBtnText}
                </Button>
            </div>
        </>
    );
});

Intro.displayName = 'Intro';
